import { Link } from 'react-router-dom';

export default function BrandIntro() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="flex-1 max-w-xl">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium border border-accent-300 text-accent-700 bg-accent-50 mb-4">
              品牌介绍
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-900 leading-tight mb-2">
              关于51暗网
            </h2>
            <p className="font-heading text-3xl md:text-4xl font-light text-foreground-500 mb-8">
              专业吃瓜黑料追踪平台
            </p>
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-6">
              51暗网成立于2024年，是国内领先的娱乐八卦新闻追踪平台。我们拥有一支由资深娱乐记者和圈内爆料人组成的专业团队，
              致力于为用户提供最新、最真实、最全面的吃瓜黑料内容。从网红塌房到明星黑料，从直播翻车到娱乐内幕，
              51暗网每日保持高频更新，确保您不错过任何一个重磅爆料。
            </p>
            <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-6">
              我们的使命是为广大吃瓜群众提供一个真实可靠的爆料平台。所有内容均经过严格审核和交叉验证，
              杜绝虚假信息和标题党。同时，我们也鼓励用户投稿爆料，共同打造最大的中文吃瓜社区。
            </p>
            <div className="flex items-center gap-8 pt-4">
              <div>
                <span className="block text-3xl font-black text-primary-500">5000万+</span>
                <span className="text-xs text-foreground-500">累计阅读量</span>
              </div>
              <div>
                <span className="block text-3xl font-black text-accent-500">12万+</span>
                <span className="text-xs text-foreground-500">忠实用户</span>
              </div>
            </div>
          </div>

          <div className="flex-1 relative">
            <div className="relative w-full max-w-md mx-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20Chinese%20digital%20newsroom%20with%20warm%20ambient%20lighting%2C%20multiple%20monitors%20displaying%20entertainment%20news%2C%20editorial%20team%20collaboration%20atmosphere%2C%20professional%20yet%20dynamic%20workspace%2C%20dark%20and%20warm%20color%20palette%20with%20golden%20accents%2C%20cinematic%20photography%20style%2C%20modern%20Chinese%20media%20company%20office&width=600&height=750&seq=about-brand-01&orientation=portrait"
                alt="51暗网团队工作场景"
                title="51暗网团队"
                className="w-full rounded-lg object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}